import { PageType } from '@blk/simba';

export const SELF_SERVICE_PORTRAIT_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

export const SELF_SERVICE_PORTRAIT_FOOTER = `
<g id="Report_AdvisorFooter" fill="#616161" font-family="FortBook" font-size="8" >
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">$date$</tspan><tspan
			text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="5">
			<tspan>$advisorName$</tspan>
		</tspan>
		<tspan x="0" y="14">
			<tspan font-family="FortBold" font-weight="bold">PREPARED BY: </tspan>
			<tspan>$clientName$</tspan>
		</tspan>
		$DCR_PA_SELF_SERVICE_FOOTER_TEMPLATE_FINANCIAL_PROFESSIONAL_DISCLOSURE$
	</text>
</g>`;
